import React , {useState} from 'react';
import PageTitle from '../../components/PageTitle';
import genStyles from '../../styles/General.module.css';
import {Button} from '@mantine/core';
import RecipesList from './recipesList';
import {useDisclosure } from '@mantine/hooks';
import RecipesPopUp from './recipesPopUp';
import { useRecipes } from '../../context/RecipeContext';
import { useSorters } from '../../context/SorterContext';
import { useNavigate } from 'react-router-dom';

const RecipesPage = () =>{
    const navigate = useNavigate();
    const [opened, { open, close }] = useDisclosure(false);

    const {recipes, addRecipe} = useRecipes();
    const {sorters} = useSorters();
       
    const uniqueSorters = Array.from(
        new Map(sorters.map(s => [`${s.id}|${s.name}`, s])).values()
    );
    const sorterOptions = uniqueSorters.map((sorter)=>({value: String(sorter.id) , label: sorter.name}))


    const onSave = async (sorter_id:number, name: string, numHoppers:number, ColorModel:number, RecyclingModel:number, ReuseModel:number) => {
       const id =  await addRecipe(name, sorter_id)
       navigate(`/recipes/${id}`)
    }
    
    return (
        <div>
            <RecipesPopUp opened={opened} close={close} title="Add" onSave={onSave} options={sorterOptions} ></RecipesPopUp>
            <PageTitle title="Recipes"></PageTitle>
            <div className={genStyles.PageMain}>
                <RecipesList data={recipes}></RecipesList>
                <div className={genStyles.AddButtonWrapper}> 
                 <Button className ={genStyles.AddButton}  onClick={open} variant="filled" color="#62929E" radius="xl">Add</Button>
                </div> 
            </div>
        </div>

    );
}

export default RecipesPage  